// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"07326733362038831d89","655":"7a9a501e425d3e7e0d5d"}[chunkId] + ".js";
};